export default __webpack_public_path__ + "static/media/pictogramBeaconBriefcase128.cf7d2382.svg";